import React from 'react'
import ImagePlaceholder, { Props } from './Image'

const HeaderPlaceholder: React.FC<Props> = (props): JSX.Element => {
	const styleProps = {
		height: '60px',
		margin: '0 auto',
		width: 'var(--max-page-width)',
		...props?.style,
	}

	return <ImagePlaceholder {...props} style={styleProps} />
}

export default HeaderPlaceholder
